package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.model.JSScriptableIndexable
import pl.decks.chartjs.radar.options.GridOptions

@Suppress("unused")
@RadarDsl
class GridScope {
    var display: Boolean = true
    private var color: JSScriptableIndexable<ChartColor>? = null
    private var lineWidth: JSScriptableIndexable<Float>? = null
    var circular: Boolean? = null

    fun color(value: ChartColor) { color = JSScriptableIndexable.Static(value) }
    fun color(values: List<ChartColor>) { color = JSScriptableIndexable.PerPoint(values) }
    fun color(fn: (dynamic) -> ChartColor) { color = JSScriptableIndexable.Scriptable(fn) }

    fun lineWidth(value: Float) { lineWidth = JSScriptableIndexable.Static(value) }
    fun lineWidth(values: List<Float>) { lineWidth = JSScriptableIndexable.PerPoint(values) }
    fun lineWidth(fn: (dynamic) -> Float) { lineWidth = JSScriptableIndexable.Scriptable(fn) }

    internal fun build() = GridOptions(
        display = display,
        color = color,
        lineWidth = lineWidth,
        circular = circular,
    )
}
